import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import DetailProfile from '../../innerSection/CategoryProfile';
import useMicroSiteEncrypt from '../../CustomHook/useMicroSiteEncrypt';
import RecaptchaComponent from '../../commonSection/RecaptchaComponent';
import { IdleTimerProvider } from 'react-idle-timer';
import { eventTracking, fetchLeaderDetailData } from '../../../redux/actions/micrositeAction';
import CategoryDetails from '../../innerSection/CategoryDetails';
import CategoryList from '../../innerSection/CategoryList';
import LeadForm from '../../innerSection/LeadForm';
import FaqAccordion from '../../innerSection/FaqAccordion';
import BenefitCarousel from '../../carouselSection/BenefitCarousel';
import WhatsappButton from '../../innerSection/WhatsappButton';
import { getNewRecaptchaToken } from '../../commonSection/RecaptchaComponent';
import Disclaimer from '../../commonSection/Disclaimer';

const CategoryContainer = (props) => {
    const dispatch = useDispatch();
    const intervalRef = useRef(null);
    const [searchParams] = useSearchParams();
    const temp_id = searchParams.get('template_id');
    const id = searchParams.get('id');
    const idleTimerRef = useRef(null);
    const { microSiteEncrypt } = useMicroSiteEncrypt();
    const theme_colors = useSelector((state) => state.microsite?.theme_colors);
    const profile_data = useSelector((state) => state.microsite?.profile_data);
    const new_microsite_extra_clt = useSelector((state) => state.microsite?.home_data?.new_microsite_extra_clt);
    const [timeoutId, setTimeoutId] = useState(null); // State to track timeout ID
    const [hasCalledApi, setHasCalledApi] = useState(false); // State to track if API call has been made
    const captcha_key =
    window.location.origin.includes("spdevmfp") ||
    window.location.origin.includes("localhost")
      ? "6LfunNgbAAAAAEM0X3hcwSBYKJwIqHmmInfz0uFK"
      : window.location.origin.includes("sppreprod") ||
        window.location.origin.includes("sptestmfp")
      ? "6Ldeg6YaAAAAAAZqU7AQ_j-lG4LcnwP4jfNFiCJJ"
      : "6Lf9fqoaAAAAAH8JhnTg9gLI3KsYKmR2tdCRVg8i";
    
    // const handleClose = () => {
    //     setModalIsOpen(false);
    // };
    
    useEffect(() => {
        if (temp_id) {
            handleNavigation("section5")
        }
    }, [temp_id])
    
    // Create a function to process URL that we can reuse
    const processUrl = () => {
        let currentUrl = window?.location?.href?.replace("/website", "");
        if (!currentUrl?.includes("category") && currentUrl?.includes(".com")) {
            currentUrl = currentUrl?.replace(".com", ".com/category");
        } else if(!currentUrl?.includes("category") && currentUrl?.includes(".in")) {
            currentUrl = currentUrl?.replace(".in", ".in/category");
        }
        return currentUrl;
    };

    const previousUrlRef = useRef(processUrl());

    useEffect(() => {
        window.scrollTo({
            top: 0,
        });
        
        // Set loading to true immediately when component mounts
        dispatch({ type: "TOGGLE_LOADING", payload: true });
        
        const startTracking = async () => {
            try {
                const tokenLeader = await microSiteEncrypt();
                if (tokenLeader && tokenLeader !== "") {
                    const result = await dispatch(fetchLeaderDetailData(tokenLeader, id));
                    
                    // After category data is loaded, preload images if available
                    if (result) {
                        const imageUrls = [];
                        
                        // Add profile image
                        if (result.profile_image) {
                            imageUrls.push(result.profile_image);
                        }
                        
                        // Add other images from the response
                        if (result.images) {
                            result.images.forEach(img => {
                                if (img) imageUrls.push(img);
                            });
                        }
                        
                        // Preload images and then hide loading
                        if (imageUrls.length > 0) {
                            try {
                                // Create a simple image preloader
                                const preloadPromises = imageUrls.map(url => {
                                    return new Promise((resolve, reject) => {
                                        const img = new Image();
                                        img.onload = () => resolve(url);
                                        img.onerror = () => reject(url); // Reject on error to ensure proper loading
                                        img.src = url;
                                    });
                                });
                                await Promise.all(preloadPromises); // Use Promise.all instead of allSettled
                                console.log('All category images preloaded successfully');
                            } catch (error) {
                                console.log('Some images failed to preload:', error);
                                // Continue even if some images fail
                            }
                        }
                        
                        // Check if content is loaded immediately after images are preloaded
                        const checkContentLoaded = () => {
                            const categoryContent = document.querySelector('[class*="bg-"]') || document.querySelector('.bg-white') || document.querySelector('[style*="background-color"]');
                            if (categoryContent && categoryContent.children.length > 0) {
                                dispatch({ type: "TOGGLE_LOADING", payload: false });
                            } else {
                                // If content not ready, wait a bit more
                                setTimeout(checkContentLoaded, 100);
                            }
                        };
                        checkContentLoaded();
                    } else {
                        // If no data returned, check content immediately
                        const checkContentLoaded = () => {
                            const categoryContent = document.querySelector('[class*="bg-"]') || document.querySelector('.bg-white') || document.querySelector('[style*="background-color"]');
                            if (categoryContent && categoryContent.children.length > 0) {
                                dispatch({ type: "TOGGLE_LOADING", payload: false });
                            } else {
                                setTimeout(checkContentLoaded, 100);
                            }
                        };
                        checkContentLoaded();
                    }
                } else {
                    // If token generation failed, check content immediately
                    const checkContentLoaded = () => {
                        const categoryContent = document.querySelector('[class*="bg-"]') || document.querySelector('.bg-white') || document.querySelector('[style*="background-color"]');
                        if (categoryContent && categoryContent.children.length > 0) {
                            dispatch({ type: "TOGGLE_LOADING", payload: false });
                        } else {
                            setTimeout(checkContentLoaded, 100);
                        }
                    };
                    checkContentLoaded();
                }

                setTimeout(() => {
                    generateEventAction("start");
                }, 2000);            
            } catch (error) {
                console.error('Error during category data loading:', error);
                // Hide loading even if there's an error
                const checkContentLoaded = () => {
                    const categoryContent = document.querySelector('[class*="bg-"]') || document.querySelector('.bg-white') || document.querySelector('[style*="background-color"]');
                    if (categoryContent && categoryContent.children.length > 0) {
                        dispatch({ type: "TOGGLE_LOADING", payload: false });
                    } else {
                        setTimeout(checkContentLoaded, 100);
                    }
                };
                checkContentLoaded();
            }
        };        
        
        startTracking();
        intervalRef.current = setInterval(() => {
            generateEventAction("call");
        }, 20000);
        
        return () => {
            clearInterval(intervalRef.current);
            generateEventAction("end");
        };
    }, [id]);
  
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        const headerOffset = 89; // Adjust based on the header height
        const elementPosition = section.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    };

    const handleNavigation = (section) => {
        window.scrollTo({
            top: 0,
        });
        setTimeout(() => {
            scrollToSection(section)
        }, 1000);
    }
    
    const generateEventAction = async (action) => {
        let tokenEvent = "";
        let url = processUrl();  // Always get the current URL
        
        // Get a fresh recaptcha token for event tracking
        let recaptcha = await getNewRecaptchaToken(captcha_key);
        
        // For "end" action, use the previous URL
        if (action === "end") {
            url = previousUrlRef.current;
        } else {
            // Update the previous URL ref with current URL for next time
            previousUrlRef.current = url;
        }

        let flow = "";
        let contact_id = "";
        if (Cookies.get("new_c")) {
            contact_id = Cookies.get("new_c");
        } else if (Cookies.get("c")) {
            contact_id = Cookies.get("c");
        }
        
        let end_time = new Date();
        tokenEvent = await microSiteEncrypt();
        if (!Cookies.get("vtkn")) {
           Cookies.set("vtkn", tokenEvent); 
        }
        if (tokenEvent && tokenEvent !== "") {
            dispatch(eventTracking(tokenEvent, recaptcha, url, action, (action === "call" || action === "end" || action === "idle") ? formatDateToISD(end_time) : "", flow, contact_id));
        }
    };
    
    function formatDateToISD(dateString) {
        const date = new Date(dateString);

        // Helper function to add leading zero
        const padZero = (num) => (num < 10 ? `0${num}` : num);

        const year = date.getFullYear();
        const month = padZero(date.getMonth() + 1); // Months are zero-indexed
        const day = padZero(date.getDate());
        const hours = padZero(date.getHours());
        const minutes = padZero(date.getMinutes());
        const seconds = padZero(date.getSeconds());

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    const handleOnIdle = () => {
        if (!hasCalledApi) {
            console.log("User is idle. Setting up timeout for API call.");

            // Set a timeout to trigger the API call after 10 minutes
            const id = setTimeout(() => {
                console.log("Making API call after 10 minutes of being idle.");
                generateEventAction("idle");
                
                clearInterval(intervalRef.current);
                
                setHasCalledApi(true); // Mark that API call has been made
            }, 10 * 60 * 1000);

            setTimeoutId(id);
        }
    };

    const handleOnActive = () => {
        console.log("User is active.");

        // Reload the page if the API call was already made once
        if (hasCalledApi) {
            console.log("Reloading page since API call was already made once.");
            window.location.reload();
        }

        // Clear the timeout if the user becomes active
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
    };

    // Add siteColors object near the top with other state/refs
    const siteColors = {
        primary: theme_colors.primary,    // Blue color
        secondary: theme_colors.secondary,  // Orange color
        textMuted: "#00000070" // Semi-transparent black
    };

    return (
        <IdleTimerProvider
            ref={idleTimerRef}
            timeout={1000}
            onIdle={handleOnIdle}
            onActive={handleOnActive}
        >
            <div className='bg-[#fff] mt-[5rem]'>
                <div className='lg:max-w-7xl hidden max-sm:block mx-auto'>
                    <DetailProfile banner={profile_data?.banner} colors={siteColors} />
                </div>
                <div className='p-4'>
                    <div className='max-sm:hidden lg:max-w-7xl mx-auto'>
                        <DetailProfile banner={profile_data?.banner} colors={siteColors} />
                    </div>
                    <div className=''>
                        <CategoryDetails detail={profile_data} colors={siteColors} />
                    </div>
                </div>
                {profile_data?.benefits?.length > 0 && <div className='px-12 max-sm:px-4 mt-12 max-sm:mt-4'>
                    <BenefitCarousel benefit={profile_data?.benefits} colors={siteColors} />
                </div>}
                
                <section id='section5' className='px-12 max-sm:px-4 mb-4'>
                    <CategoryList data={profile_data?.case_data} colors={siteColors} />
                </section>

                {profile_data?.faq?.length > 0 && <div className='px-12 max-sm:px-4 my-12'>
                    <FaqAccordion faq={profile_data?.faq} colors={siteColors} />
                </div>}
                
                <section id='section4' style={{ backgroundColor: siteColors.primary }}>
                    <LeadForm colors={siteColors} />
                </section>
                <section id='section7' style={{ backgroundColor: siteColors.primary }} className='bg-[#2167A7]'>
                        <Disclaimer colors={siteColors} microsite_clt={new_microsite_extra_clt} />
                </section>
            </div>
            <WhatsappButton colors={siteColors} />
        </IdleTimerProvider>
    );
};

export default CategoryContainer;
